import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ReturnFrames, User } from '@app/core/models';
import { select, State, Store } from '@ngrx/store';
import { AppState, selectProfile } from '@app/core/ngrx';
import { Router } from '@angular/router';

/**
 * ShoppingCartComponent
 */
@Component({
  selector: 'ecp-frame-returns-cart',
  templateUrl: './frame-returns-cart.component.html',
  styleUrls: ['./frame-returns-cart.component.scss'],
})
export class FrameReturnsCartComponent implements OnInit, AfterViewInit {
  @ViewChild('stickyMenu') menuElement: ElementRef;
  user$: Observable<User>;
  frameReturns$: Observable<ReturnFrames[]>;
  patientId;
  url = '/frame-return';
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private state: State<AppState>,
  ) {}

  ngOnInit() {
    this.user$ = this.store.pipe(select(selectProfile));

    this.frameReturns$ = this.store.pipe(
      select(state => state.frameReturns.frameReturns),
    );
    /*     this.frameReturns$.subscribe(frames => {
      if (frames.length === 0) {
        this.user$.subscribe(user => {
          if (user) {
            this.patientId = this.state.getValue().user.patientID;
          }
        });
      }
    }); */
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}
